import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';

@Injectable({
  providedIn: 'root',
})
export class ListExportHttpService extends BaseHttpService {
  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public downloadExport(exportPath: string) {
    const url = this.routerService.mount(exportPath.replace(/^\//, ''));
    return this.readBlob(url);
  }
}
